const MAX_DIGITS = {
  cpf: 11,
  cnpj: 14,
  tel: 11,
  cep: 8,
  date: 8,
};

const stripNonDigits = (value) => String(value ?? '').replace(/\D/g, '');

const applyPattern = (digits, pattern) => {
  let output = '';
  let index = 0;

  for (const char of pattern) {
    if (index >= digits.length) break;
    if (char === '#') {
      output += digits[index];
      index += 1;
    } else {
      output += char;
    }
  }

  return output;
};

const patternFormatter = (pattern, maxDigits) => (value) => {
  const digits = stripNonDigits(value).slice(0, maxDigits);
  return applyPattern(digits, pattern);
};

const stripToBranchChars = (value) => String(value ?? '').toUpperCase().replace(/[^\dX]/g, '');

const formatters = {
  cpf: patternFormatter('###.###.###-##', MAX_DIGITS.cpf),
  cnpj: patternFormatter('##.###.###/####-##', MAX_DIGITS.cnpj),
  tel: patternFormatter('(##) #####-####', MAX_DIGITS.tel),
  cep: patternFormatter('#####-###', MAX_DIGITS.cep),
  date: patternFormatter('##/##/####', MAX_DIGITS.date),
  number: (value) => stripNonDigits(value),
  bankBranch: stripToBranchChars,
  percent: (value) => {
    const cleaned = String(value ?? '').replace(/[^\d.]/g, '');
    return cleaned ? `${cleaned}%` : '';
  },
};

const placeholders = {
  cpf: '000.000.000-00',
  cnpj: '00.000.000/0000-00',
  tel: '(00) 00000-0000',
  cep: '00000-000',
  date: 'dd/mm/yyyy',
  percent: '%',
  money: 'R$',
  number: '',
};

export const applyMask = (value, mask) => {
  const formatter = formatters[mask];
  return formatter ? formatter(value) : value;
};

export const getPlaceholder = (mask) => placeholders[mask] ?? '';

export const hasMask = (mask) => Boolean(formatters[mask]);
